import { ToteProgramAPIService, UserAPIService } from '@amwager/data-access';
import { AUTH_FEATURE_KEY, AuthEffects, AuthFacade, authReducer } from './+state';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

export * from './+state';


export const authenticationProviders = [
  UserAPIService, // need by AuthEffects
  ToteProgramAPIService, // need by common-auth.guard

  // ngrx
  AuthFacade,
  provideState(AUTH_FEATURE_KEY, authReducer),
  provideEffects(AuthEffects),
];
